export enum VoucherCodeStatuses {
  SoldInShop = 'Im Geschäft verkauft',
  Generated = 'generiert',
  Used = 'gebraucht',
  Redeemed = 'eingelöst',
  SoldOnline = 'Online verkauft',
}
